import React, { useState, useEffect } from 'react';
import UploadLogo from './uploadLogo';
import Course from './course';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import MicroModuleListing from './microModuleListing';
import Lottie from "lottie-react";

const Dashboard = () => {
    const [orgDetails, setOrgDetails] = useState()
    const [loader, setLoader] = useState(true);
    const [showUploadLogo, setShowUploadLogo] = useState(false);
    const orgInfo = JSON.parse(localStorage.getItem("orgInfo"));

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        const fetchUserDetails = async () => {
            try {
                // let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
                // if (orgInfo && orgInfo?.org_image && orgInfo?.org_image != null && orgInfo?.org_image != "null") {
                //     setShowUploadLogo(true);
                // } else {
                    setLoader(true);
                    const token = apiService.getAuthToken()
                    const org_id = localStorage.getItem("ORGID")
                    apiService.getv1(`get-org-details/${org_id}`, token).then((result) => {
                        localStorage.setItem('orgInfo', JSON.stringify(result?.data))
                        if (result && result?.status == "success" && result?.data?.org_image && result?.data?.org_image != null && result?.data?.org_image != "null") {
                            setShowUploadLogo(true);
                            setLoader(false);
                        }
                    })
                // }
            } catch (error) {
                setLoader(false);
                console.error("Error fetching user details:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchUserDetails();
    }, []);

    const [complianceData, setComplianceData] = useState(null);
    const [policyData, setPolicyData] = useState(null);
    const [templateData, setTemplateData] = useState(null);

    useEffect(() => {
        const fetchLottie = async () => {
            try {
                const [complianceRes, policyRes, templateRes] = await Promise.all([
                    fetch("/images/compliance.json"),
                    fetch("/images/Policy.json"),
                    fetch("/images/template.json"),
                ]);

                const [compliance, policy, template] = await Promise.all([
                    complianceRes.json(),
                    policyRes.json(),
                    templateRes.json(),
                ]);

                setComplianceData(compliance);
                setPolicyData(policy);
                setTemplateData(template);
            } catch (error) {
                console.error("Error loading Lottie files:", error);
            }
        };

        fetchLottie();
    }, []);

    return (
        <>
                <div className='page__main'>
                    <div className="dashboard" style={{ minHeight: '100vh' }}>
                        <div className="container-fluid mb-4">
                            <div className="row d-flex flex-row align-items-center gap-2">
                                <div className="col-12 px-0">
                                    <div className="row align-items-stretch">
                                        {/* Welcome Message + Image */}
                                        <div className={localStorage.getItem('image') || showUploadLogo ? "col-lg-12" : "col-lg-8"}>
                                            <div className="bg-white card border-radius-20 p-4 h-100 d-flex flex-row align-items-center">
                                                <div className="col-7">
                                                    <h1 className="font-26 fw-bold text-start mb-4">
                                                        Welcome to Inclusional
                                                    </h1>
                                                    <p className="lead font-18 fw-bold text-start mb-3">
                                                        Empowering organisations with inclusive knowledge and growth!
                                                    </p>
                                                    <p className="h6 fw-regular text-start">
                                                        Get a step-by-step guide to effortlessly comply with the law of the land, invite employees to courses,
                                                        track progress status, and much more!
                                                    </p>
                                                </div>
                                                <div className="col-5 text-end">
                                                    <img src="/images/Layer_2.svg" alt="Illustration" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Upload Logo */}
                                        <div className="col-lg-4 mt-0">
                                          {loader ? <Loader /> : <>
                                           {localStorage.getItem('image') || showUploadLogo ? null : <>
                                           <div className='bg-white card border-radius-20 px-2 pt-3 h-100 d-flex flex-row align-items-center'> <UploadLogo></UploadLogo>
                                           </div></>} 
                                           </> }
                                          {/* <UploadLogo></UploadLogo> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {orgInfo?.plan_id !== 'plan_1234567892' && (
                        <div className="container-fluid p-0 mb-4">
                            <div className="row m-0">
                                <div className="col-12 p-0">
                                    <h1 className="font-26 fw-bold text-start mb-4">
                                        Quick actions to get you started
                                    </h1>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-md-4">
                                    <div className="card h-auto shadow-sm compliance-card">
                                        <div className="card-body d-flex flex-column align-items-center text-center">
                                            <div className="mb-1 text-center">
                                                {complianceData && (
                                                    <Lottie
                                                        animationData={complianceData}
                                                        loop
                                                        autoplay
                                                        style={{ height: 120, width: 120 }}
                                                    />)}
                                            </div>
                                            <h2 className="card-title fw-regular small my-2">
                                                View compliance checklist to ensure your organisation has
                                                fulfilled all the mandatory requirements
                                            </h2>
                                            <div className='align-self-end mt-2'>
                                                <a href='/compliance/682af7f019e1e20f435fb179' className="btn text-white mt-auto compliance-btn">
                                                    View Compliance
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card h-auto shadow-sm policy-card">
                                        <div className="card-body d-flex flex-column align-items-center text-center">
                                            <div className="mb-0 text-center mb-custom">
                                                {policyData && (
                                                    <Lottie
                                                        animationData={policyData}
                                                        loop
                                                        autoplay
                                                        style={{ height: 116, width: 116 }}
                                                    />
                                                )}
                                            </div>
                                            <h2 className="card-title fw-regular small my-2">
                                                Consider uploading your POSH policy so that your employees can
                                                view it on the dashboard
                                            </h2>
                                            <div className="align-self-end mt-3 mt-custom">
                                                <a href='/compliance/682af7f019e1e20f435fb179' className="btn text-white mt-auto policy-btn">
                                                    Upload Policy
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
           
                                <div className="col-md-4">
                                    <div className="card h-auto shadow-sm templates-card">
                                        <div className="card-body d-flex flex-column align-items-center text-center">
                                            <div className="mb-1 text-start">
                                                {templateData && (
                                                    <Lottie
                                                        animationData={templateData}
                                                        loop
                                                        autoplay
                                                        style={{ height: 120, width: 120 }}
                                                    />
                                                )}
                                            </div>
                                            <h2 className="card-title fw-regular small my-2">
                                                Browse IC appointment letter, POSH posters and much more, to
                                                support you with compliance requirements
                                            </h2>
                                            <div className='align-self-end mt-2'>
                                                <a href='/template_library' className="btn text-white mt-auto templates-btn">
                                                    Browse Templates
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        )} */}
                        {/* {localStorage.getItem("image") || showUploadLogo ? null : <UploadLogo></UploadLogo>} */}
                        <Course></Course>
                        {/* {(orgInfo?.plan_id !== 'plan_1234567892' && orgInfo?.plan_id !== 'plan_1234567896' && orgInfo?.plan_id !== 'plan_1234567890') && (
                        <MicroModuleListing></MicroModuleListing> )} */}
                    </div>
                </div>
        </>
    )
}

export default Dashboard;
